import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { LinkBtnComponent } from '@enginuity/core/molecules/tertiary/link-btn.component';

@Component({
  selector: 'app-onboarding-header',
  imports: [NgOptimizedImage, LinkBtnComponent],
  templateUrl: './onboarding-header.component.html',
  styleUrl: './onboarding-header.component.scss',
})
export class OnboardingHeaderComponent {
  @Input() centered: boolean = false;
  @Input() cancelable: boolean = false;
  @Output() onCancel = new EventEmitter();

  handleCancel() {
    this.onCancel.emit();
  }
}
